import "./../../bindings/bao-searcher";
import GenericListSearchTab from "./../../factories/generic-list-search-tab";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
class RoleColumnProfileTab extends GenericListSearchTab {
    Bao = Bao;
    DialogWidth = 500;
    CustomFilter() {
        return null;
    }
    SearchType() {
        return "ColumnProfile";
    }
    ItemCompleteCheck(item): JQueryPromise<boolean> {
        var def = $.Deferred<boolean>();
        var result = true;
        if (item.ColumnProfile() == null) {
            result = false;
        }
        if (!result) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        def.resolve(result);
        return def.promise();
    }
}
export default RoleColumnProfileTab;